import React from "react";
import tw from "twin.macro";
import { SectionHeading } from "components/misc/Headings.js";
import { Container as ContainerBase, ContentWithPaddingXl } from "components/misc/Layouts";

/*
 * Previously dotted-border boxes on a solid purple band with a fade-up
 * animation. Rebuilt as plain numbered steps.
 *
 * Copy note: step 3 used to say "Easily onboard your team from a spreadsheet
 * or directory". There is no bulk import or directory sync in the app -
 * users are invited one at a time - so it now describes what exists.
 */
const Container = tw(ContainerBase)`bg-gray-100 -mx-8 px-8`;
const Heading = tw(SectionHeading)`text-center`;
const Intro = tw.p`mt-4 text-center text-lg text-gray-800 max-w-xl mx-auto`;
const Steps = tw.ol`mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4 max-w-screen-xl mx-auto`;
const Step = tw.li`bg-white rounded-xl p-8 border border-gray-200`;
const StepNumber = tw.span`flex items-center justify-center w-10 h-10 rounded-full bg-primary-500 text-white font-bold`;
const Title = tw.h3`mt-6 text-xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-gray-800 leading-relaxed`;

const steps = [
  { title: "Choose a plan", description: "Pick the tier that fits your organisation's size. Every feature is included." },
  { title: "Add your branding", description: "Upload your logo and set your colours so the portal feels like your own." },
  { title: "Invite your team", description: "Invite caseworkers and staff by email, or let them sign in with Microsoft." },
  { title: "Share your reporting link", description: "Give employees your anonymous reporting link and they can report straight away." },
];

export default () => (
  <Container>
    <ContentWithPaddingXl>
      <Heading>Get started in four steps</Heading>
      <Intro>No installation and no IT project — EthosHub runs entirely in the browser.</Intro>
      <Steps>
        {steps.map((s, i) => (
          <Step key={s.title}>
            <StepNumber aria-hidden="true">{i + 1}</StepNumber>
            <Title>{s.title}</Title>
            <Description>{s.description}</Description>
          </Step>
        ))}
      </Steps>
    </ContentWithPaddingXl>
  </Container>
);
